import { render, staticRenderFns } from "./HorizontalProduct.vue?vue&type=template&id=0f72f942"
import script from "./HorizontalProduct.vue?vue&type=script&lang=js"
export * from "./HorizontalProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports